export const SLUG_PATTERN = /^[a-z][a-z0-9_]*$/;
export const MAX_SLUG_LENGTH = 70;
